import { MouseEvent } from "react"
import { Link } from "react-router-dom"
import { HasId, IPost } from "src/libs/interfaces/layouts"
import { __, jsonToData } from "src/libs/utilities"
import { getDownload } from "src/libs/utilities/getDownloadFile"
import { useDataStore } from "src/modules/pe-basic-module/data/store"
import * as XLSX from 'xlsx'
import { actions } from "../../data/actions"
import { GET_TEST_ACTION, GET_TEST_RESULTS_USERS_ACTION, GET_TEST_USER_RESULTS_ACTION } from "../../data/actionTypes"
import { IPETest } from "../../data/interfaces"
import { getAnswerCategoryData, getCVGData } from "../../data/utils/getCVGData"
import useTestCategories from "../../hooks/useTestCategories"

/* Protopia Ecosystem component */
export interface ITestIndexProps {
   
}
const TestIndex = (props: ITestIndexProps): JSX.Element => {
    useTestCategories()
    const PETestCategory : IPost[] = useDataStore((state: any) => state.PETestCategory)
    
    const onEmptyClick = (e: MouseEvent<HTMLAnchorElement> ) => {
        e.preventDefault()
        e.stopPropagation()
        
        let sheets: any = {}
        let sheetNames: string[] = []
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        const fileExtension = '.xlsx'
        let userName: string = ""
        let userDescr: any = {}
        let promises: any[] = []

        actions(GET_TEST_ACTION, {id: -1})
        .then(() => {
            actions(
                GET_TEST_RESULTS_USERS_ACTION,
                { }
            ).then((res: any[]) => {
                res.map(r => r.user ).forEach(r => {
                    promises.push( new Promise((resolve, reject) => { 
                        actions(
                            GET_TEST_USER_RESULTS_ACTION,
                            {
                                user_id: r.id
                            }
                        )
                        .then((res: any[]) => {
                            // console.log( res )
                            res.forEach(r => {
                                
                                let cats : any[] = []
                                let test:IPETest = (useDataStore.getState().PETest || []).find( (t: HasId) => t.id === r.test_id)
                                userName =  r.user.display_name 
                                userDescr = jsonToData(r.user.user_descr)
                                const age = userDescr ? `(${userDescr.age})` : ""
                                const csvData = getAnswerCategoryData(r.results, test, userName)
                                const testTitle = test.title 
 
                                csvData.forEach(c => {
                                    if(!cats[ c.cat_id ]) {
                                        cats[ c.cat_id ] = { 
                                            [__("Answer")]: PETestCategory.find(tc => tc.id === c.cat_id)?.title || c.cat_id, 
                                            [__("Value")] : 0
                                        }
                                    }
                                    cats[ c.cat_id ][__("Value")] += Number(c.value)
                                })
                                cats = cats.filter( c => !!c) 
                                const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet( cats )

                                const nm = (userName.substring(0, 15) + age + ":" + testTitle.substring(0, 15))
                                sheetNames.push( nm )
                                sheets[ nm ] = ws
                                console.log( ws )
                            }) 
                            resolve(true)
                        })
                    }))
                }) 
                
                Promise.all( promises ).then(() => {
                    const wb : XLSX.WorkBook = { Sheets: sheets, SheetNames: sheetNames }
                    console.log( wb )
                    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
                    const data = new Blob([excelBuffer], {type: fileType})
                    getDownload(data, "testResults_full"+ fileExtension)
                })
            })
        })
    }
    return <div className='row '>
        <div className="col-md-4">
            <Link to={"users"} className="card aspect-ratio-1 bg-secondary flex-centered hover mx-md-0 mx-5">
                <div className="h lead text-light">
                    {__("Users")}
                </div>
            </Link>
        </div>
        <div className="col-md-4">
            <Link to={"all-tests"} className="card aspect-ratio-1 bg-success flex-centered hover mx-md-0 mx-5">
                <div className="h lead text-light">
                    {__("Tests")}
                </div>
            </Link>
        </div>
        <div className="col-md-4">
            <a href="#ff" className="card aspect-ratio-1 bg-danger flex-centered hover mx-md-0 mx-5" onClick={onEmptyClick}>
                <i className="far fa-file-excel fa-2x my-2 mx-1 text-light"></i>
            </a>
        </div>
    </div>
}
export default TestIndex